// extracted by mini-css-extract-plugin
module.exports =  {"container":"HjXzkYnUSkjTDvhBrIOQ","animations":"Vw3IWDWiLzBSULBLvPBB","buttons":"raEsgL8EvMFp1FVoCNSS","input":"Vs7WCpyObPzIb4wlWm8O","programName":"F2HbGQgiue9o56F2LMCr"};